<template>
    <div class="block-curtain-wrapper">
        <span class="block-curtain-block">K</span>
        <span class="block-curtain-block">R</span>
        <span class="block-curtain-block">A</span>
        <span class="block-curtain-block">K</span>
        <span class="block-curtain-block">E</span>
        <span class="block-curtain-block">N</span>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'

    export default Vue.extend({
        name: 'Blockcurtain'
    })
</script>

<style scoped lang="scss">
    .block-curtain {
        &-wrapper {
            position: fixed;
            left: 0;
            top: 0;
            width: 100vw;
            height: 100vh;
            z-index: 99;
            pointer-events: none;
            display: flex;
        }

        &-block {
            display: inline-block;
            width: calc( 100vw / 6 );
            height: 0;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2.5rem;
            color: transparent;
        }
    }
</style>